import React from 'react'
import { Route, useRouteMatch } from 'react-router'

import Notifications from '../../pages/Notifications'

const NotificationsRoute = () => {
  const { path } = useRouteMatch()

  return <Route path={path} component={Notifications} />
}

export default NotificationsRoute
